import { Link } from 'react-router-dom';
import { BackButton } from '../Components/Simple';

export default function Unauthorized() {
  return (
    <div className="py-2">
      <div className="row my-2 justify-content-between sticky top g-0 border-bottom align-items-center">
        <div className="col-auto">
          <BackButton />
        </div>
      </div>
      <h2> Error: You are unauthorized to view this page. </h2>
      <Link to="/"> Back to Home Page </Link>
    </div>
  )
};
